
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useTheme() {
  const location = useLocation();
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    // Ensure the saved theme is either 'light' or 'dark', otherwise default to 'dark'
    return (savedTheme === 'dark' || savedTheme === 'light') ? savedTheme : 'dark';
  });

  // Check if current route is landing page
  const isLandingPage = location.pathname === '/' || location.pathname === '/landing-page';

  useEffect(() => {
    const root = document.documentElement;
    
    // Force light theme for landing page, dark for all others
    if (isLandingPage) {
      root.classList.remove('dark');
      setTheme('light');
      localStorage.setItem('theme', 'light');
    } else {
      root.classList.add('dark');
      setTheme('dark');
      localStorage.setItem('theme', 'dark');
    }
  }, [location.pathname, isLandingPage]);

  // Apply theme immediately on mount
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    // Only allow theme toggle on non-landing pages
    if (!isLandingPage) {
      setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    }
  };

  // Function to force dark theme (for non-landing pages)
  const forceDarkTheme = () => {
    if (!isLandingPage) {
      setTheme('dark');
    }
  };

  // Function to force light theme (for landing page)
  const forceLightTheme = () => {
    if (isLandingPage) {
      setTheme('light');
    }
  };

  return [theme, toggleTheme, forceDarkTheme, forceLightTheme];
}

export default useTheme;
